const INITIAL_STATE = {
  showButtons: 0
};

export const eventsHomeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SHOW_EVENTS_BUTTONS':
      return {
        ...state,
        showButtons: action.payload
      };
    default:
      return state;
  }
};
